import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isFalsy } from 'lib/Helpers';
import * as styles from './Checkbox.scss';

/**
 * @class Checkbox
 * @classdesc Reusable Checkbox Component
 * @property {Object} state
 * @property {Object} checkboxRef
 * @example ./Checkbox.md
 */
export default class Checkbox extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    indeterminate: PropTypes.bool,
    name: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    ),
  };

  static defaultProps = {
    disabled: false,
    indeterminate: null,
    name: '',
    text: '',
    className: null,
    wrapperClassName: null,
    style: null,
  };

  constructor(props) {
    super(props);
    const { checked } = this.props;

    this.state = {
      checked,
    };
    this.checkboxRef = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.checked !== prevState.checked) return { checked: nextProps.checked };
    return null;
  }

  componentDidMount() {
    const { indeterminate } = this.props;

    if (isFalsy(indeterminate)) return null;
    this.checkboxRef.indeterminate = indeterminate;
    return null;
  }

  componentDidUpdate(prevProps) {
    const { indeterminate } = this.props;
    if (prevProps.indeterminate !== indeterminate && this.checkboxRef) this.checkboxRef.indeterminate = indeterminate;
  }

  changeHandler = e => {
    const { disabled, onChange } = this.props;
    const { checked } = this.state;

    if (disabled) return null;
    this.setState({ checked: !checked });
    return onChange(!checked);
  };

  render() {
    const { className, disabled, name, style, text, wrapperClassName } = this.props;
    const { checked } = this.state;

    return (
      <div className={classNames(styles.checkbox, wrapperClassName)} style={style}>
        <input
          className={className}
          type="checkbox"
          onChange={() => {}}
          onClick={this.changeHandler}
          checked={checked}
          name={name}
          disabled={disabled}
          ref={this.checkboxRef}
        />
        {text && <p className={styles.checkboxLabel} onClick={this.changeHandler}>{text}</p>}
      </div>
    );
  }
}
